<script lang="ts">
    import { createEventDispatcher } from "svelte"
    import TextField from "../fields/TextField.svelte"
    import { _ } from "lodash"
    import { _ as _s } from "svelte-i18n"
    import Select from "svelte-select"
    import { appliedPricegroups, login } from "../../../../../store"
    import { getPriceCalculationByDealers } from "../../../../../api"
    import { mdiBookSearch, mdiClose } from "@mdi/js"
    import Icon from "../../../../widgets/Icon.svelte"
    import hash from "object-hash"
    import {
        applyPCalc,
        applyPCalcOnSinglePosition,
        calculateDiscountPercent,
        calculatePriceWithVAT,
    } from "../../../../../functions/operations/pricegroup"
    import Modal from "../../../../widgets/Modal.svelte"
    import Checkbox from "../../../../widgets/Checkbox.svelte"
    import { tooltip } from "../../../../../helper"
    import { normalizeVat } from "../../../../../../../api/hooks/config-client"
    export let position: Partial<OperationPositionOut>
    export let operation: OperationOut
    export let readonly: boolean = false
    //cypress
    if (!position) position = {}
    position = JSON.parse(JSON.stringify(position))
    operation = JSON.parse(JSON.stringify(operation))

    let VAT = normalizeVat(operation.endCustomerVAT)

    let initialProcentualSurcharge = !isNaN(position?.priceWizard?.surcharge)
        ? position.priceWizard.surcharge
        : ((position?.endCustomerPrice || 0) / position?.netPrice - 1) * 100
    let initialProcentualDiscount = !isNaN(position?.priceWizard?.discount) ? position.priceWizard.discount : 0

    interface WizardValues {
        price: number[]
        surcharge: number
        subtotal: number[]
        discount: number
        sellingPrice: number[]
        additionalPositions: [number, number][]
        tax: number
        total: number[]
        showDiscount: boolean
        // nur gesetzt, wenn sich der aktuelle Netto-Einstandspreis vom
        // berechneten Einstandspreis unterscheidet (siehe unten)
        currentPrice?: number[]
    }

    let values: WizardValues = {
        price: [position?.netPrice, calculatePriceWithVAT(position?.netPrice, VAT)],
        surcharge: initialProcentualSurcharge,
        subtotal: [0, 0],
        discount: initialProcentualDiscount,
        sellingPrice: [0, 0],
        additionalPositions: [] as [number, number][],
        tax: VAT,
        total: [0, 0],
        showDiscount: operation?.showDiscount || false,
    }

    if (position.currentNetPrice) {
        if (position.currentNetPrice !== position.netPrice) {
            values.currentPrice = [position.currentNetPrice, calculatePriceWithVAT(position.currentNetPrice, VAT)]
        }
    }

    let originalValues: null = null
    let originalHash: null = null
    let priceWizardChanged = false

    let modified = false

    const dispatch = createEventDispatcher()

    position?.additionalItems?.forEach((p) => {
        values.additionalPositions.push([p.netPrice * p.amount, p.netPrice * (1 + values.tax / 100) * p.amount])
    })

    let oldTotal = [...values.total]
    let oldSubTotal = [...values.subtotal]
    let oldSellingPrice = [...values.sellingPrice]
    let oldAdditionalPositions = JSON.parse(JSON.stringify(values.additionalPositions))

    function rerenderPriceWizard() {
        initialProcentualSurcharge = !isNaN(position?.priceWizard?.surcharge)
            ? position.priceWizard.surcharge
            : ((position?.endCustomerPrice || 0) / calculatePriceWithVAT(position?.netPrice, 19) - 1) * 100
        initialProcentualDiscount = !isNaN(position?.priceWizard?.discount) ? position.priceWizard.discount : 0
        VAT = normalizeVat(operation.endCustomerVAT)
        values = {
            price: [position?.netPrice, calculatePriceWithVAT(position?.netPrice, VAT)],
            surcharge: initialProcentualSurcharge,
            subtotal: [0, 0],
            discount: initialProcentualDiscount,
            sellingPrice: [0, 0],
            additionalPositions: [],
            tax: VAT,
            total: [0, 0],
            showDiscount: values?.showDiscount ?? (operation?.showDiscount || false),
        }
        position?.additionalItems?.forEach((p) => {
            values.additionalPositions.push([p.netPrice * p.amount, p.netPrice * (1 + values.tax / 100) * p.amount])
        })
        recalculateValues()
    }

    function recalculateValues() {
        let netSubtotal = values.price[0] * (1 + values.surcharge / 100)
        let grossSubtotal = netSubtotal * (1 + values.tax / 100)

        let netDiscount = netSubtotal * (values.discount / 100)
        let netSellingPrice = netSubtotal - netDiscount

        let total = netSellingPrice * (1 + values["tax"] / 100) * position?.quantity
        total += values.additionalPositions.map((p) => p[1]).reduce((a, b) => a + b, 0)

        values.subtotal = [netSubtotal, grossSubtotal]
        values.sellingPrice = [netSellingPrice, netSellingPrice * (1 + values.tax / 100)]
        values.total = [total / (1 + values.tax / 100), total]

        oldAdditionalPositions = JSON.parse(JSON.stringify(values.additionalPositions))
        oldTotal = [...values.total]
        oldSubTotal = [...values.subtotal]
        oldSellingPrice = [...values.sellingPrice]
    }
    recalculateValues()
    let initialValues = JSON.parse(JSON.stringify(values))
    function changeTotal(
        netTotal: boolean,
        oldTotal: number[],
        newTotal: number,
        refPrice: number[],
        valuetype: "surcharge" | "discount"
    ) {
        if (refPrice[0] === 0 || refPrice[1] === 0) return
        const idx = netTotal ? 0 : 1
        const difference = valuetype == "discount" ? oldTotal[idx] - newTotal : newTotal - oldTotal[idx]
        const percentage = (difference / refPrice[idx]) * 100
        values[valuetype] += percentage
    }

    function changeTotalChainVersion() {
        let aPS = values?.additionalPositions?.map((p) => p[0]).reduce((a, b) => a + b, 0)
        let discountPercent = calculateDiscountPercent(
            values.price[0],
            values.surcharge,
            aPS,
            values.total[0],
            position
        )
        values.discount = discountPercent
    }

    function getSingePrice(
        idx: number,
        values: {
            price?: number[]
            surcharge?: number
            subtotal?: number[]
            discount?: number
            sellingPrice?: number[]
            additionalPositions: any
            tax?: number | undefined
            total: any
            showDiscount?: boolean
        }
    ) {
        return (
            (values.total[idx] -
                values?.additionalPositions
                    .map((p: { [x: string]: any }) => p[idx])
                    .reduce((a: any, b: any) => a + b, 0)) /
            position?.quantity
        )
    }
    let apply = false
    let addPosAmount: any[] = []
    let showApplyApprove = false
    let showApplyApproveMargin = false
    let applyPCalcRestricted = false
    async function applyPriceWizard() {
        if (_.isEqual(initialValues, values)) {
            dispatch("close")
        }
        position?.additionalItems?.forEach((e, i) => {
            position.additionalItems[i].amount = addPosAmount[i]
            position.additionalItems[i].netPrice = values.additionalPositions[i][0] / addPosAmount[i]
        })
        position.endCustomerPrice = getSingePrice(0, values)
        position.endCustomerPriceGross = getSingePrice(1, values)
        operation.endCustomerVAT = normalizeVat(values.tax)
        position.priceWizard = {
            surcharge: values.surcharge,
            discount: values.discount,
        }
        let pcalc = pCalcs?.find((pcalc) => pcalcValue?.value && pcalc?.id == pcalcValue?.value)
        if (pcalc && !applyPCalcRestricted) {
            const result = await applyPCalc(pcalc, operation)
            if (Array.isArray(result)) {
                operation = result[0] as OperationOut
            } else {
                operation = result as OperationOut
            }
            setTimeout(() => {
                $appliedPricegroups[operation?.id] = [
                    `${pcalc.groupName || $_s("components.pcalcGroup.globalPriceGroup")} - ${$_s(
                        "components.pcalcGroup.dealerNr"
                    )}: ${pcalc.dealerNumber}` || "",
                    hash(operation),
                ]
            }, 100)
        }
        if (!pcalc) {
            $appliedPricegroups[operation?.id] = ["Manuelle Angabe", hash(operation)]
            operation.appliedPCalc = ""
        }
        dispatch("apply", { operation, position })
        dispatch("close")
    }

    $: {
        if (apply) {
            applyPriceWizard()
        }
    }

    position?.additionalItems?.forEach((p) => {
        addPosAmount.push(p.amount)
    })
    function updateVATValues() {
        values["subtotal"][1] = values["subtotal"][0] * (1 + values.tax / 100)
        values["sellingPrice"][1] = values["sellingPrice"][0] * (1 + values.tax / 100)
        values["total"][1] = values["total"][0] * (1 + values.tax / 100)
        values?.additionalPositions?.forEach((p) => {
            p[1] = p[0] * (1 + values.tax / 100)
        })
        recalculateValues()
    }

    let pCalcs: PriceCalculation[] = []
    let pcalcValues: { value: string; label: string }[] = []

    setTimeout(() => {
        initialPCalcApply = false
    }, 700)
    const loadOptions = async () => {
        let response = await getPriceCalculationByDealers([
            $login?.account?.ident?.dealerNumber,
            ...($login?.tokenData?.dealers || []),
        ])
        if (response.data.length) {
            pCalcs = response.data
            pcalcValues = []
            response.data.forEach((p) => {
                // if (p.groupName)
                pcalcValues.push({
                    value: p.id,
                    label: `${p.groupName || $_s("components.pcalcGroup.globalPriceGroup")} - ${$_s(
                        "components.pcalcGroup.dealerNr"
                    )}: ${p.dealerNumber}`,
                })
            })
            if ($appliedPricegroups?.[operation?.id]) {
                pcalcValue = pcalcValues.find((p) => p.label == $appliedPricegroups?.[operation?.id]?.[0])
            } else {
                hashedValues = hash(values)
            }
        }
        return pcalcValues
    }

    // value ist null, solange keine globale Preisgruppe gewählt ist ("Manuell")
    let pcalcValue: { label: string; value: string | null } = {
        label: $appliedPricegroups?.[operation?.id]?.[0] || $_s("components.priceWizard.selectPriceGroup"),
        value: null,
    }

    let initialPCalcApply = true
    async function applyPCalcFn() {
        if (initialPCalcApply) {
            hashedValues = hash(values)
            return
        }
        let pcalc = pCalcs?.find((pcalc) => pcalcValue?.value && pcalc?.id == pcalcValue?.value)
        operation = await applyPCalcOnSinglePosition(
            pcalc,
            operation,
            operation.positions.findIndex((p) => p.number === position.number)
        )
        position = operation.positions.find((p) => p.number === position.number)

        rerenderPriceWizard()
        hashedValues = hash(values)
    }
    $: if (
        pcalcValue?.value &&
        pCalcs?.find((pcalc) => pcalcValue?.value && pcalc?.id == pcalcValue?.value) &&
        !initialPCalcApply
    ) {
        applyPCalcFn()
    }
    let hashedValues: any
    function changePricegroup() {
        if (hash(values) !== hashedValues && pcalcValue?.value !== "Manuell") {
            pcalcValue = {
                label: "Manuell",
                value: null,
            }
        }
    }
    $: if (values && hashedValues) {
        changePricegroup()
    }

    originalValues = JSON.parse(JSON.stringify(values))
    originalHash = hash(values)
    priceWizardChanged = false

    $: {
        if (hash(values) !== originalHash) {
            priceWizardChanged = true
        } else {
            priceWizardChanged = false
        }
    }
</script>

<div class="pricewizard">
    <div class="pricestep-block">
        <div class="pricestep-block-rows">
            <div class="header pricestep-block-row">
                <div class="upper-header">
                    <div>{$_s("components.priceWizard.entirePriceGroup")}</div>
                    <Select
                        inputAttributes="{{ autocomplete: 'off' }}"
                        placeholder=""
                        showChevron="{true}"
                        clearable="{true}"
                        {loadOptions}
                        bind:value="{pcalcValue}"
                        disabled="{readonly}"
                        on:clear="{() => {
                            pcalcValue = {
                                label: $_s('components.priceWizard.selectPriceGroup'),
                                value: null,
                            }
                        }}"
                    >
                        <div slot="clear-icon">
                            <Icon path="{mdiClose}" size="24px" />
                        </div>
                        <div slot="chevron-icon">
                            <Icon path="{mdiBookSearch}" size="24px" />
                        </div>
                    </Select>
                </div>
                <div class="upper-header">
                    <Checkbox
                        disabled="{readonly}"
                        checked="{operation.showDiscount}"
                        on:checked="{() => {
                            operation.showDiscount = true
                            values.showDiscount = true
                        }}"
                        on:unchecked="{() => {
                            operation.showDiscount = false
                            values.showDiscount = false
                        }}"
                        label="{$_s('components.priceWizard.showDiscountPDFs')}"
                        cssClass="primary "
                    />
                </div>
                <div class="columns">
                    <h4>{$_s("components.priceWizard.costType")}</h4>
                    <h4>{$_s("components.priceWizard.net")}</h4>
                    <h4>
                        {$_s("components.priceWizard.gross")}
                        <div class="percentage-input">
                            <TextField
                                readonlyNumber="{readonly}"
                                showTwoDecimals="{true}"
                                type="number"
                                cssClass="input"
                                label="{$_s('components.priceWizard.percentageInput')}"
                                value="{values['tax']}"
                                on:updated="{(e) => {
                                    if (values['tax'] !== e.detail) modified = true
                                    values['tax'] = e.detail
                                    updateVATValues()
                                }}"
                                on:blur="{recalculateValues}"
                            />
                        </div>
                    </h4>
                </div>
            </div>
        </div>
    </div>
    <div class="pricestep-block content">
        <div class="pricestep-block-rows">
            <!-- Einstandspreis row -->
            {#if values.currentPrice}
                <div class="pricestep-block-row">
                    <div class="title">
                        <p>{$_s("components.priceWizard.currentPurchasePrice")}</p>
                    </div>

                    <div class="input-container" style="justify-content: flex-start; padding: 10px;">
                        <span>{((values["currentPrice"][0] * 1000) / 1000).toFixed(3)}</span> €
                    </div>
                    <div class="input-container" style="justify-content: flex-start; padding: 10px;">
                        <span>{(Math.round(values["currentPrice"][1] * 100) / 100).toFixed(2)}</span> €
                    </div>
                </div>
                <div class="pricestep-block-row">
                    <div class="title">{$_s("components.priceWizard.difference")}</div>

                    <div class="input-container" style="justify-content: flex-start; padding: 10px;">
                        <span>{(((values["price"][0] - values["currentPrice"][0]) * 1000) / 1000).toFixed(3)}</span> €
                    </div>
                    <div class="input-container" style="justify-content: flex-start; padding: 10px;">
                        <span
                            >{(Math.round((values["price"][1] - values["currentPrice"][1]) * 100) / 100).toFixed(
                                2
                            )}</span
                        > €
                    </div>
                </div>
                <div class="pricestep-block-row">
                    <div class="title" style="flex-direction: column; align-items: start;">
                        <p>{$_s("components.priceWizard.originalPurchasePrice")}</p>
                        <small>{$_s("components.priceWizard.basisForCalculations")}</small>
                    </div>

                    <div class="input-container" style="justify-content: flex-start; padding: 10px;">
                        <span>{((values["price"][0] * 1000) / 1000).toFixed(3)}</span> €
                    </div>
                    <div class="input-container" style="justify-content: flex-start; padding: 10px;">
                        <span>{(Math.round(values["price"][1] * 100) / 100).toFixed(2)}</span> €
                    </div>
                </div>
            {:else}
                <div class="pricestep-block-row">
                    <div class="title">{$_s("components.priceWizard.purchasePrice")}</div>

                    <div class="input-container" style="justify-content: flex-start; padding: 10px;">
                        <span>{((values["price"][0] * 1000) / 1000).toFixed(3)}</span> €
                    </div>
                    <div class="input-container" style="justify-content: flex-start; padding: 10px;">
                        <span>{(Math.round(values["price"][1] * 100) / 100).toFixed(2)}</span> €
                    </div>
                </div>
            {/if}

            <!-- Aufschlag row: rot bei keinem/negativem Aufschlag (Verlust) -->
            <div class="pricestep-block-row subrow" class:loss="{values.surcharge <= 0}">
                <div class="title">{$_s("components.priceWizard.surcharge")}</div>
                <div class="percentage-input">
                    <TextField
                        readonlyNumber="{readonly}"
                        showThreeDecimals="{true}"
                        type="number"
                        cssClass="input"
                        label="{$_s('components.priceWizard.inputInPercent')}"
                        value="{values['surcharge']}"
                        decimal="{3}"
                        on:updated="{(e) => {
                            if (values['surcharge'] == e.detail) return
                            values['surcharge'] = e.detail
                        }}"
                        on:blur="{recalculateValues}"
                    />
                    <TextField
                        readonlyNumber="{readonly}"
                        decimal="{3}"
                        showThreeDecimals="{true}"
                        type="number"
                        cssClass="input"
                        label="{$_s('components.priceWizard.specificationInEur')}"
                        showEuroSymbol="{true}"
                        value="{(values['surcharge'] / 100) * values['price'][0]}"
                        on:blur="{(e) => {
                            if (values['surcharge'] == (e.detail / values['price'][0]) * 100) return
                            values['surcharge'] = (e.detail / values['price'][0]) * 100
                            recalculateValues()
                        }}"
                    />
                </div>
                <div class="percentage-input">
                    <TextField
                        readonlyNumber="{readonly}"
                        showTwoDecimals="{true}"
                        type="number"
                        cssClass="input"
                        label="{$_s('components.priceWizard.inputInPercent')}"
                        on:updated="{(e) => {
                            if (values['surcharge'] == e.detail) return
                            values['surcharge'] = e.detail
                        }}"
                        value="{values['surcharge']}"
                        on:blur="{recalculateValues}"
                    />
                    <TextField
                        readonlyNumber="{readonly}"
                        showTwoDecimals="{true}"
                        type="number"
                        cssClass="input"
                        label="{$_s('components.priceWizard.specificationInEur')}"
                        showEuroSymbol="{true}"
                        value="{(values['surcharge'] / 100) * values['price'][1]}"
                        decimal="{3}"
                        on:blur="{(e) => {
                            if (values['surcharge'] == (e.detail / values['price'][1]) * 100) return
                            values['surcharge'] = (e.detail / values['price'][1]) * 100
                            recalculateValues()
                        }}"
                    />
                </div>
            </div>

            <!-- Zwischensumme row -->
            <div class="pricestep-block-row" class:loss="{values.price[0] > values.subtotal[0]}">
                <div class="title">{$_s("components.priceWizard.subtotal")}</div>
                <div class="input-container">
                    <TextField
                        readonlyNumber="{readonly}"
                        showThreeDecimals="{true}"
                        type="number"
                        cssClass="input"
                        label="{$_s('components.priceWizard.specificationInEur')}"
                        showEuroSymbol="{true}"
                        decimal="{3}"
                        on:updated="{(e) => {
                            values['subtotal'][0] = e.detail
                        }}"
                        on:blur="{(e) => {
                            changeTotal(true, oldSubTotal, e.detail, values.price, 'surcharge')
                            oldSubTotal = [...values.subtotal]
                            recalculateValues()
                        }}"
                        value="{values['subtotal'][0]}"
                    />
                </div>
                <div class="input-container">
                    <TextField
                        readonlyNumber="{readonly}"
                        showTwoDecimals="{true}"
                        type="number"
                        cssClass="input"
                        label="{$_s('components.priceWizard.specificationInEur')}"
                        showEuroSymbol="{true}"
                        on:updated="{(e) => {
                            values['subtotal'][1] = e.detail
                        }}"
                        on:blur="{(e) => {
                            changeTotal(false, oldSubTotal, e.detail, values.price, 'surcharge')
                            oldSubTotal = [...values.subtotal]
                            recalculateValues()
                        }}"
                        value="{values['subtotal'][1]}"
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="pricestep-block content">
        <div class="pricestep-block-rows">
            <!-- Rabatt % row -->
            <div class="pricestep-block-row subrow">
                <div class="title">{$_s("components.priceWizard.discount")}</div>
                <div class="percentage-input">
                    <TextField
                        readonlyNumber="{readonly}"
                        showThreeDecimals="{true}"
                        type="number"
                        cssClass="input"
                        label="{$_s('components.priceWizard.inputInPercent')}"
                        decimal="{3}"
                        value="{values['discount']}"
                        on:updated="{(e) => {
                            if (values['discount'] == e.detail) {
                                return
                            }
                            values['discount'] = e.detail
                        }}"
                        on:blur="{(e) => {
                            values['discount'] = e.detail
                            recalculateValues()
                        }}"
                    />
                    <TextField
                        readonlyNumber="{readonly}"
                        showThreeDecimals="{true}"
                        type="number"
                        cssClass="input"
                        label="{$_s('components.priceWizard.inputInEUR')}"
                        showEuroSymbol="{true}"
                        decimal="{3}"
                        value="{(values['discount'] / 100) * values['subtotal'][0]}"
                        on:blur="{(e) => {
                            if (values['discount'] == (e.detail / values['subtotal'][0]) * 100) return
                            values['discount'] = (e.detail / values['subtotal'][0]) * 100
                            recalculateValues()
                        }}"
                    />
                </div>
                <div class="percentage-input">
                    <TextField
                        readonlyNumber="{readonly}"
                        showTwoDecimals="{true}"
                        type="number"
                        cssClass="input"
                        label="{$_s('components.priceWizard.inputInPercent')}"
                        value="{values['discount']}"
                        on:updated="{(e) => {
                            if (values['discount'] == e.detail) return
                            values['discount'] = e.detail
                        }}"
                        on:blur="{(e) => {
                            values['discount'] = e.detail
                            recalculateValues()
                        }}"
                    />
                    <TextField
                        readonlyNumber="{readonly}"
                        showTwoDecimals="{true}"
                        type="number"
                        cssClass="input"
                        label="{$_s('components.priceWizard.inputInEUR')}"
                        showEuroSymbol="{true}"
                        value="{(values['discount'] / 100) * values['subtotal'][1]}"
                        on:blur="{(e) => {
                            if (values['discount'] == (e.detail / values['subtotal'][1]) * 100) return
                            values['discount'] = (e.detail / values['subtotal'][1]) * 100
                            recalculateValues()
                        }}"
                    />
                </div>
            </div>

            <!-- Abgabepreis row -->
            <div class="pricestep-block-row" class:loss="{values.price[0] > values.sellingPrice[0]}">
                <div class="title">{$_s("components.priceWizard.sellingPrice")}</div>
                <div class="input-container">
                    <TextField
                        readonlyNumber="{readonly}"
                        showThreeDecimals="{true}"
                        type="number"
                        cssClass="input"
                        label="{$_s('components.priceWizard.inputInEUR')}"
                        showEuroSymbol="{true}"
                        decimal="{3}"
                        value="{values['sellingPrice'][0]}"
                        on:updated="{(e) => {
                            values['sellingPrice'][0] = e.detail
                        }}"
                        on:blur="{(e) => {
                            changeTotal(true, oldSellingPrice, e.detail, values.subtotal, 'discount')
                            oldSellingPrice = [...values.sellingPrice]
                            recalculateValues()
                        }}"
                    />
                </div>
                <div class="input-container">
                    <TextField
                        readonlyNumber="{readonly}"
                        showTwoDecimals="{true}"
                        type="number"
                        cssClass="input"
                        label="{$_s('components.priceWizard.inputInEUR')}"
                        showEuroSymbol="{true}"
                        value="{values['sellingPrice'][1]}"
                        on:updated="{(e) => {
                            values['sellingPrice'][1] = e.detail
                        }}"
                        on:blur="{(e) => {
                            changeTotal(false, oldSellingPrice, e.detail, values.subtotal, 'discount')
                            oldSellingPrice = [...values.sellingPrice]
                            recalculateValues()
                        }}"
                    />
                </div>
            </div>

            <div class="pricestep-block-row">
                <div class="title">{$_s("components.priceWizard.RRP")}</div>

                <div class="input-container" style="justify-content: flex-start; padding: 10px;">
                    {position.retailPrice} €
                </div>
                <div class="input-container" style="justify-content: flex-start; padding: 10px;">
                    {calculatePriceWithVAT(position.retailPrice, VAT)} €
                </div>
            </div>
        </div>
    </div>
    <div class="seperator">
        <div class="line"></div>
        <div class="multiplied">✕ {position?.quantity} ({$_s("components.priceWizard.quantity")})</div>
    </div>
    <div class="pricestep-block content">
        <div class="pricestep-block-rows">
            {#each position?.additionalItems || [] as item, i}
                <!-- Zusatzposition row -->
                <div class="pricestep-block-row">
                    <div class="title">{$_s("components.priceWizard.additionalPositionNumber")} {item.number}</div>
                    <div class="input-container">
                        <TextField
                            readonlyNumber="{readonly}"
                            showThreeDecimals="{true}"
                            type="number"
                            cssClass="input"
                            higherThanZero="{true}"
                            decimal="{3}"
                            label="{$_s('components.priceWizard.inputInEUR')}"
                            showEuroSymbol="{true}"
                            value="{values['additionalPositions'][i][0] / (addPosAmount[i] || 1)}"
                            on:updated="{(e) => {
                                let value = e.detail
                                if (value <= 0) value = 1
                                values['additionalPositions'][i][0] = value * addPosAmount[i]
                                values['additionalPositions'][i][1] = value * (1 + values.tax / 100) * addPosAmount[i]
                            }}"
                            on:blur="{recalculateValues}"
                        />
                    </div>
                    <div class="input-container">
                        <TextField
                            readonlyNumber="{readonly}"
                            showTwoDecimals="{true}"
                            type="number"
                            cssClass="input"
                            label="{$_s('components.priceWizard.inputInEUR')}"
                            higherThanZero="{true}"
                            showEuroSymbol="{true}"
                            value="{values['additionalPositions'][i][1] / (addPosAmount[i] || 1)}"
                            on:updated="{(e) => {
                                let value = e.detail
                                if (value <= 0) value = 1
                                values['additionalPositions'][i][1] = value * (addPosAmount[i] || 1)
                                values['additionalPositions'][i][0] =
                                    (value / (1 + values.tax / 100)) * (addPosAmount[i] || 1)
                            }}"
                            on:blur="{recalculateValues}"
                        />
                    </div>
                    <div class="input-container">
                        ✕&nbsp;
                        <TextField
                            readonlyNumber="{readonly}"
                            type="number"
                            cssClass="input"
                            label="{$_s('components.priceWizard.quantity')}"
                            decimal="{0}"
                            higherThanZero="{true}"
                            value="{addPosAmount[i]}"
                            on:updated="{(e) => {
                                let value = e.detail
                                if (value <= 0) value = 1
                                values['additionalPositions'][i][0] /= addPosAmount[i] || 1
                                values['additionalPositions'][i][1] /= addPosAmount[i] || 1
                                addPosAmount[i] = value
                                values['additionalPositions'][i][0] *= addPosAmount[i] || 1
                                values['additionalPositions'][i][1] *= addPosAmount[i] || 1
                            }}"
                            on:blur="{recalculateValues}"
                        />
                    </div>
                </div>
            {/each}

            <!-- Verkaufspreis row -->
            <div
                class="pricestep-block-row"
                class:loss="{values.price[0] >
                    (values.total[0] - values?.additionalPositions?.map((p) => p[0]).reduce((a, b) => a + b, 0)) /
                        position?.quantity}"
            >
                <div class="title">{$_s("components.priceWizard.sellingPrice")}</div>
                <div class="input-container">
                    <TextField
                        readonlyNumber="{readonly}"
                        showThreeDecimals="{true}"
                        type="number"
                        cssClass="input"
                        label="{$_s('components.priceWizard.inputInEUR')}"
                        decimal="{3}"
                        value="{values['total'][0]}"
                        showEuroSymbol="{true}"
                        on:updated="{(e) => {
                            values['total'][0] = e.detail
                        }}"
                        on:blur="{(e) => {
                            values['total'][0] = e.detail
                            changeTotalChainVersion()
                            oldTotal = [...values.total]
                            recalculateValues()
                        }}"
                    />
                </div>
                <div class="input-container">
                    <TextField
                        readonlyNumber="{readonly}"
                        showTwoDecimals="{true}"
                        type="number"
                        cssClass="input"
                        label="{$_s('components.priceWizard.inputInEUR')}"
                        showEuroSymbol="{true}"
                        value="{values['total'][1]}"
                        on:updated="{(e) => {
                            values['total'][1] = e.detail
                            values['total'][0] = e.detail / (1 + values.tax / 100)
                        }}"
                        on:blur="{(e) => {
                            values['total'][0] = e.detail / (1 + values.tax / 100)
                            values['total'][1] = e.detail
                            changeTotalChainVersion()
                            oldTotal = [...values.total]
                            recalculateValues()
                        }}"
                    />
                </div>
            </div>
        </div>
        <div class="buttons" style="display: flex; justify-content: space-between; width: 100%;">
            <button
                class="cancel btn btn-secondary"
                on:click="{() => {
                    dispatch('close')
                }}"><p>{readonly ? $_s("general.close") : $_s("general.cancel")}</p></button
            >
            {#if !readonly}
                {#key priceWizardChanged}
                    <div style="display: flex; flex-direction: column;  position: relative;">
                        {#if priceWizardChanged}
                            <button
                                type="button"
                                data-cy="cancel"
                                style="border: 0px; padding: 0px; background: transparent; position: absolute; top: -20px;"
                                use:tooltip="{{
                                    content: $_s('components.priceWizard.resetConfirmation'),
                                }}"
                                on:click="{() => {
                                    values = JSON.parse(JSON.stringify(originalValues))
                                    originalHash = hash(values)
                                    priceWizardChanged = false
                                    addPosAmount = []
                                    position?.additionalItems?.forEach((p) => {
                                        addPosAmount.push(p.amount)
                                    })
                                    recalculateValues()
                                }}"
                            >
                                {$_s("general.reset")}
                            </button>
                        {/if}
                        <div
                            use:tooltip="{{
                                content: priceWizardChanged
                                    ? 'invalid'
                                    : $_s('components.priceWizard.priceGroupNotModified'),
                            }}"
                        >
                            <button
                                class="apply btn"
                                disabled="{!priceWizardChanged}"
                                on:click="{() => {
                                    let pcalc = pCalcs?.find(
                                        (pcalc) => pcalcValue?.value && pcalc?.id == pcalcValue?.value
                                    )
                                    if (pcalc) {
                                        if (operation.positions.length == 1) {
                                            apply = true
                                        } else showApplyApprove = true
                                    } else if (values['price'][0] > values['sellingPrice'][0]) {
                                        showApplyApproveMargin = true
                                    } else apply = true
                                }}"
                            >
                                {$_s("general.apply")}</button
                            >
                        </div>
                    </div>
                {/key}{/if}
        </div>
    </div>
</div>
<Modal
    bind:show="{showApplyApprove}"
    size="md"
    showCloseIcon="{false}"
    on:close="{() => {
        showApplyApprove = false
    }}"
>
    <div slot="header">{$_s("components.priceWizard.applyConfirmation")}</div>
    <p>{$_s("components.priceWizard.applyPriceGroupPrompt")}</p>
    <div slot="footer">
        <div style="display: flex; justify-content: space-between; width: 100%;">
            <button
                class="btn btn-secondary"
                on:click="{() => {
                    showApplyApprove = false
                }}"
            >
                {$_s("general.cancel")}
            </button>

            <div style="display: flex; gap: 10px;">
                <button
                    class="btn"
                    data-cy="save-restricted"
                    on:click|preventDefault|stopPropagation="{() => {
                        apply = true
                        showApplyApprove = false
                        applyPCalcRestricted = true
                    }}"
                >
                    {$_s("components.priceWizard.applyRestricted")}
                </button>

                <button
                    class="btn"
                    data-cy="save"
                    on:click|preventDefault|stopPropagation="{() => {
                        apply = true
                        showApplyApprove = false
                    }}"
                >
                    {$_s("components.priceWizard.applyEntireOperation")}
                </button>
            </div>
        </div>
    </div>
</Modal>

<Modal
    bind:show="{showApplyApproveMargin}"
    size="sm"
    showCloseIcon="{false}"
    on:close="{() => {
        showApplyApproveMargin = false
    }}"
>
    <div slot="header">{$_s("components.priceWizard.applyConfirmation")}</div>
    <p>{$_s("components.priceWizard.applyMarginWarning")}</p>
    <div slot="footer">
        <div style="display: flex; justify-content: space-between; width: 100%;">
            <button
                class="btn btn-secondary"
                on:click="{() => {
                    showApplyApproveMargin = false
                }}"
            >
                {$_s("general.cancel")}
            </button>

            <button
                class="btn"
                data-cy="save"
                on:click|preventDefault|stopPropagation="{() => {
                    apply = true
                    showApplyApproveMargin = false
                }}"
            >
                {$_s("general.apply")}
            </button>
        </div>
    </div>
</Modal>
